export default "__VITE_ASSET__c9421928__"